import { Redirect } from "wouter";

export default function ReferralPage() {
  return <Redirect to="/dashboard" />;
}
